import { createActionGroup, createAction, props } from '@ngrx/store';

/**
 * @deprecated The method should not be used, use `RedirectActions.redirectToUrl` instead
 */
export const redirect = createAction('[REDIRECT] Redirect', props<{ url: string }>());

export const RedirectActions = createActionGroup({
    source: 'Redirect',
    events: {
        'Redirect To Url': props<{ url: string }>(),
    },
});

export default RedirectActions;
